import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICollection, ICollectionOrder, IDtoResponse } from '@app/shared/models/dtos/response.dto';
import { CollectionParam } from '@app/shared/models/param.model';
import { APP_CONFIG } from '@shared/config/app.config';
import { map, Observable } from 'rxjs';
import { IOrderDetail, IOrderRow } from '@app/shared/models/order.model';
import { ServiceBase } from '../base/base.service';
import { PATH } from '@app/shared/types/enums/path';
import { ActionEnum } from '@app/shared/types/enums/ActionEnum.enum';

@Injectable({
  providedIn: 'root',
})
export class OrderService extends ServiceBase {
  constructor(private readonly http: HttpClient) {
    super(`${APP_CONFIG.serviceBaseUrl}/onboarding/api/v1/order`);
  }

  getOrders(rppUserId: string, params: CollectionParam): Observable<ICollection<IOrderRow> | undefined> {
    const headers = new HttpHeaders().set('monitoring_view', PATH.ORDERS).set('monitoring_action', ActionEnum.READ);

    return this.http
      .get<IDtoResponse<ICollection<IOrderRow>>>(`${this.baseUrl}/${rppUserId}/requests`, {
        params: new HttpParams()
          .set('pageIndex', params.pageIndex.toString())
          .set('pageSize', params.pageSize.toString())
          .set('fetch_address_to', true),
        headers,
      })
      .pipe(map(res => res.data));
  }

  getOrderDetail(rppUserId: string, orderId: number | null): Observable<ICollectionOrder<IOrderDetail> | undefined> {
    const headers = new HttpHeaders().set('monitoring_view', PATH.ORDERS).set('monitoring_action', ActionEnum.READ);

    return this.http
      .get<IDtoResponse<ICollectionOrder<IOrderDetail>>>(`${this.baseUrl}/${rppUserId}/request/${orderId}`, {
        params: new HttpParams().set('pageIndex', '0').set('pageSize', '5'),
        headers,
      })
      .pipe(map(res => res.data));
  }

  updateOrderStatus(cardCode: string, agentEmail: string): Observable<IDtoResponse<null>> {
    const headers = new HttpHeaders()
      .set('email', agentEmail.toString())
      .set('monitoring_view', PATH.ORDERS)
      .set('monitoring_action', ActionEnum.UPDATE);

    return this.http.patch<IDtoResponse<null>>(`${this.baseUrl}/${cardCode}/orders/status`, null, { headers });
  }

}
